var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-generator"},[_vm._l((_vm.content),function(section,index){return [_c(section.component,_vm._b({key:index,tag:"component"},'component',section.fields,false))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }